import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { ApplyPipeModule, CalendarPickerModule, TitleContentComponent  } from 'ngx-zcs-components';
import { IonicModule } from '@ionic/angular';
import { MatChipsModule } from '@angular/material/chips';
import { MatSortModule } from '@angular/material/sort';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';

import { AlertsListComponent } from './alerts-list.component';
import { BlockTitleComponent } from '../../components/block-title/block-title.component';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [
    AlertsListComponent,
  ],
  imports: [
    ApplyPipeModule,
    BlockTitleComponent,
    CalendarPickerModule,
    CommonModule,
    IonicModule,
    MatChipsModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatNativeDateModule,
    MatSelectModule,
    MatSortModule,
    MatTableModule,
    MatTooltipModule,
    TitleContentComponent,
  ],
  exports: [
    AlertsListComponent,
  ],
})
export class AlertsListModule { }
